import React, { useEffect } from "react";
import { Spin } from "antd";
import {
  BagDetailsUI,
  ShipmentDetailsUI,
} from "@innofulfill/hubops-shipment-tracking";
import "@innofulfill/hubops-shipment-tracking/dist/assets/hubops-shipment-tracking.css";
import Smcs_Loader from "../../assests/images/loader-new.gif";
import { useEnrichedTrackingData } from "../../hooks/useEnrichedTrackingData";
import AuditHistoryPortal from "../AuditHistoryPanel/AuditHistoryPortal";
import "../AuditHistoryPanel/style.scss";
import "./style.scss";
import {
  clearPrefetchedTrackingData,
  installTrackingFetchInterceptor,
  registerPrefetchedTrackingData,
} from "../../utils/trackingFetchInterceptor";

installTrackingFetchInterceptor();

const hasBagDetails = (data) => {
  const bagging = data?.baggingTracking;
  if (!bagging) {
    return false;
  }
  const info = bagging?.baggingInfo;
  const travel = bagging?.travelInfoDto;
  const shipments = bagging?.bagShipmentNo;
  return !!(
    info ||
    (Array.isArray(travel) && travel.length) ||
    (Array.isArray(shipments) && shipments.length)
  );
};

const hasShipmentDetails = (data) =>
  !!(
    data?.shipmentTracking?.bookingInfoDto ||
    (Array.isArray(data?.shipmentTracking?.travelDtos) &&
      data.shipmentTracking.travelDtos.length) ||
    (Array.isArray(data?.shipmentTracking?.route_info) &&
      data.shipmentTracking.route_info.length)
  );

const EnrichedTrackingView = ({
  endpoint,
  awbNumber,
  showBackArrow = false,
}) => {
  const { data, loading } = useEnrichedTrackingData(endpoint, awbNumber);
  const normalizedAwb = awbNumber?.replace(/\+/g, "/")?.replace(/\s/g, "");

  useEffect(() => {
    if (!normalizedAwb || !data) {
      return undefined;
    }

    registerPrefetchedTrackingData(normalizedAwb, data);

    return () => {
      clearPrefetchedTrackingData(normalizedAwb);
    };
  }, [normalizedAwb, data]);

  if (!normalizedAwb) {
    return null;
  }

  if (loading && !data) {
    return (
      <div className="enriched-tracking-loader">
        <Spin
          spinning
          indicator={
            <img src={Smcs_Loader} style={{ height: 100, width: 100 }} alt="" />
          }
        />
      </div>
    );
  }

  if (hasBagDetails(data) && !hasShipmentDetails(data)) {
    return (
      <BagDetailsUI
        endpoint={endpoint}
        awbNumber={normalizedAwb}
        showBackArrow={showBackArrow}
        data={data}
      />
    );
  }

  if (hasShipmentDetails(data)) {
    const auditInfo = data?.shipmentTracking?.auditInfo || [];

    return (
      <div className="enriched-tracking-view">
        <ShipmentDetailsUI
          endpoint={endpoint}
          awbNumber={normalizedAwb}
          data={data}
        />
        <AuditHistoryPortal auditInfo={auditInfo} showWhenEmpty />
      </div>
    );
  }

  if (showBackArrow) {
    return (
      <BagDetailsUI
        endpoint={endpoint}
        awbNumber={normalizedAwb}
        showBackArrow={showBackArrow}
        data={data}
      />
    );
  }

  return (
    <ShipmentDetailsUI endpoint={endpoint} awbNumber={normalizedAwb} data={data} />
  );
};

export default EnrichedTrackingView;
